export default {
  issuerBankData: [],
  activeAccount: {},
};
